var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilityRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7141 0C13.3985 0 13.1427 0.255837 13.1427 0.571439V2.65885C10.2008 -0.189375 5.50694 -0.113371 2.65871 2.82854C1.31641 4.215 0.567586 6.07021 0.571303 7.99998C0.571303 8.31559 0.82714 8.57142 1.14274 8.57142C1.45834 8.57142 1.71415 8.31559 1.71415 7.99998C1.71485 4.52849 4.52959 1.71482 8.00112 1.71552C9.76419 1.71586 11.446 2.45665 12.6365 3.75713L10.105 4.60111C9.80524 4.70086 9.64302 5.02473 9.74276 5.32453C9.8425 5.62433 10.1664 5.78655 10.4662 5.6868L13.8947 4.54396C14.1288 4.46601 14.2864 4.24664 14.2856 3.99997V0.571406C14.2856 0.255837 14.0297 0 13.7141 0Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8573 7.42871C14.5417 7.42871 14.2858 7.68455 14.2858 8.00015C14.2851 11.4716 11.4704 14.2853 7.99885 14.2846C6.23578 14.2843 4.55394 13.5435 3.36352 12.243L5.89494 11.399C6.19473 11.2993 6.35696 10.9754 6.25721 10.6756C6.15747 10.3758 5.8336 10.2136 5.5338 10.3133L2.10523 11.4562C1.87119 11.5341 1.71359 11.7535 1.71436 12.0002V15.4287C1.71436 15.7443 1.9702 16.0002 2.2858 16.0002C2.6014 16.0002 2.85724 15.7443 2.85724 15.4287V13.3413C5.79918 16.1895 10.493 16.1135 13.3412 13.1716C14.6835 11.7851 15.4324 9.92993 15.4286 8.00015C15.4287 7.68455 15.1729 7.42871 14.8573 7.42871Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityRefresh);
export default __webpack_public_path__ + "static/media/utility--refresh.e4ec815ad02f3dd51601daf1c14be040.svg";
export { ForwardRef as ReactComponent };